import { useState } from 'react';

import Button from 'components/common/Button';
import NumberSelector from 'components/common/NumberSelector';
import Text from 'components/common/Text';
import useScreenSizeConstants from 'hooks/useScreenSizeConstants';

const AdultsKidsSelector = ({
  onContinue,
  defaultAdults = 2,
  defaultKids = 0,
  isSubmitting = false,
  error,
}) => {
  const [adults, setAdults] = useState(defaultAdults);
  const [kids, setKids] = useState(defaultKids);
  const { isUnderBp1 } = useScreenSizeConstants();

  const handleContinue = () => {
    onContinue({ adults, kids });
  };

  return (
    <>
      <div className="mb-6">
        <div className="flex items-center justify-between border-b border-solid border-charcoal-60 pb-6">
          <Text className="text-left font-semibold" brandStylesOverrides="h5 bp1:h4">
            {isUnderBp1 ? 'Adults' : 'Number of Adults'}
          </Text>
          <NumberSelector value={adults} onChange={setAdults} min={1} name="number of adults" />
        </div>

        <div className="flex items-center justify-between pt-6">
          <Text className="text-left font-semibold" brandStylesOverrides="h5 bp1:h4">
            {isUnderBp1 ? 'Kids' : 'Number of Kids'}
          </Text>
          <NumberSelector value={kids} onChange={setKids} name="number of kids" />
        </div>
      </div>

      {error && (
        <div className="mb-4">
          <Text brandStylesOverrides="textSm text-negative">{error}</Text>
        </div>
      )}

      <Button
        className="w-full bp1:mb-48"
        onClick={handleContinue}
        isSubmitting={isSubmitting}
        variation="Pill"
      >
        Continue
      </Button>
    </>
  );
};

AdultsKidsSelector.propTypes = {
  onContinue: PropTypes.func.isRequired,
  defaultAdults: PropTypes.number,
  defaultKids: PropTypes.number,
  isSubmitting: PropTypes.bool,
  error: PropTypes.string,
};

export default AdultsKidsSelector;
